namespace Gordic.Epk.WebControls {

    /** typ vyřízení (interface) */
    export interface IEpkTypeSettlement {
        /** hodnota typu vyřízení */
        value: Wfl.Interface.GWflczpvEnum | string,
        /** popisek */
        caption: string
    }

    const { gcontent } = Decorators;


    //todo: po spuštění hromadného vyřízení vypnout editaci gridu

    /**
    * Hromadné vyřízení EPK (new)
    */
    @gcontent
    export class GEpkMultiSettlement extends GContentBase<GEpkDbParamsNew> {

        //#region -- parametry --

        /** společné metody */
        private common = new GEpkCommon();
        /** vstupní způsob vyřízení */
        private zpus_vyriz: Wfl.Interface.GWflczpvEnum;
        /* žádosti pro hromadné vyřízení */
        private rows: Gordic.Wfl.Interface.GPodpisovaKnihaDto[];

        /** pouze ke čtení */
        private isReadOnly: boolean = false;

        /** podepsat obraz */
        private signFavorite = "signFavorite";
        /** timestamp */
        private timeStampColumnName = "timestamp";
        /** signAttachment */
        private signAttachmentColumnName = "signAttachment";
        /** convert */
        private convertColumnName = "convert";
        /** timestampAttachment */
        private timestampAttachmentColumnName = "timestampAttachment";
        /** convertAttachment */
        private convertAttachmentColumnName = "convertAttachment";
        /** signAttachmentNoPDF */
        private signAttachmentNoPDFColumnName = "signAttachmentNoPDF";

        /** stav výstupu hromadného vyřízení */
        private outputStateColumnName = "state";
        /** typ požadavku */
        private typPozadPodColumnName = "typ_pozad_pod";
        /** způsob vyřízení */
        private zpusVyrizColumnName = "zpus_vyriz";
        /** důvod vyřízení */
        private vyrizeniTxtColumnName = "vyrizeni_txt";

        //#endregion

        private customLogger: Gordic.Diagnostics.GLog;
        private states: GEpkRowState;

        public onContentReady() {
            this.init();
        }

        private initLog() {
            this.customLogger = new Gordic.Diagnostics.GLog({
                name: "Gordic.Epk.WebControls.GEpkMultiSettlement",
                fileName: "GEpkMultiSettlement.ts",
                authorCode: 487
            });
        }

        //#region -- INIT -- 

        private init() {

            this.initLog();

            this.showFlash({
                id: "flashNewSettlement",
                state: "info",
                content: "jres:32000612" //RC 32000612 : Vyřízení lze upřesnit změnou na řádku žádosti v editačním seznamu.
            });

            // set init data to rows
            this.rows.map((row) => {
                // thazmuka (30.03.2021) - zalogování do WK logu výchozí typ požadavku, který jde na dialog
                this.setLog("Init", row.ixp!, row.typ_pozad_pod);
                row[this.zpusVyrizColumnName] = this.zpus_vyriz;
                this.states = this.setStateOnRow(row);
                this.setNewPropertyToRow(row, this.states);
            })

            var view = this.createView();
            this.createCommandbar(view);
            var columns = this.createGridFormat();
            var searchColumns = this.searchColumns(columns);
            this.createGrid(view, columns, searchColumns);

            var fastMultiSettlement = false;
            if (this.globalSettings != null) {
                fastMultiSettlement = this.globalSettings.get("Global.Epk.AppSettings.FastMultiSettlement");
            }

            if (fastMultiSettlement === true) {
                if (this.actions.actSettlement != null) {
                    // todo:
                    // neberu v potaz důvody vyřízení
                    // neberu v potaz více certifikátů - bude potřeba mít pouze jeden
                    // zatím v testu pouze na DEBUG z uživ. nastavení
                    // později asi DB parametru
                    this.actions.actSettlement.run();
                }
            }

        }

        //#region --- VIEW ---

        /** vytvořit view dat pro grid */
        private createView() {
            var view = new Gordic.Data.View(this.rows, {
                key: "ixp, ser_cislo",
                processors: {
                    error: new Gordic.Data.ErrorProcessor((datarow, mmetarow) => {
                        // thazmuka (26.8.2020) - vyčištění předchozích chyb, jinak se nesmažou, pokud další chyba nenastane
                        mmetarow.errors = undefined;
                        var errors = this.setGridErrors(datarow);
                        return errors;
                    })
                }
            });
            return view;
        }

        /**
         * nasetování errorů na ErrorProcessor
         */
        private setGridErrors(datarow: Gordic.Wfl.Interface.GPodpisovaKnihaDto) {
            var result: Gordic.Validators.GridError[] = [];

            function gridErrorSign(columnName: string) {
                return {
                    group: "mygroup",
                    message: "jres:32000838", //RC 32000838 : Hodnota podepsat musí být vyplněna nebo se musí podepsat aspoň příloha.
                    columnName: columnName,
                    errorType: "error",
                };
            }

            function gridError(columnName: string) {
                return {
                    group: "mygroup",
                    message: "jres:32000598", //RC 32000598 : Povinná hodnota
                    columnName: columnName,
                    errorType: "error",
                };
            }

            if (datarow.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.Podepsat || datarow.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.PodepsatASchvalit) {
                if ((datarow[this.signFavorite] == null || datarow[this.signFavorite] === false) && (datarow[this.signAttachmentColumnName] == null || datarow[this.signAttachmentColumnName] === false)) {
                    result.push(gridErrorSign(this.signFavorite));
                }
            }

            if (datarow.zpus_vyriz == null) {
                result.push(gridError("zpus_vyriz"));
            }
            if (datarow.typ_pozad_pod == null) {
                result.push(gridError("typ_pozad_pod"));
            }
            // (thazmuka 06.04.2021) - edit: vynucení kladného důvodu vyřízení na DB parametr 
            if (datarow.zpus_vyriz === Wfl.Interface.GWflczpvEnum.VracenoKPrepracovani || this.EpkParams.epk_shreaspos === true) {
                if (datarow.vyrizeni_txt == null || datarow.vyrizeni_txt.length === 0) {
                    result.push(gridError("vyrizeni_txt"));
                }
            }
            return result;
        }

        //#endregion

        private flashIdAddWithoutComment = "flashIdAddWithoutComment";

        private createCommandbar(view: Gordic.Data.View<Gordic.Wfl.Interface.GPodpisovaKnihaDto>) {
            var params: MenuParams[] = [];

            params.push({
                favorite: true,
                action: new GAction({
                    icon: "gi-window-close",
                    caption: "jres:32000611", //RC 32000611 : Zavřít
                    name: "actClose",
                    run: () => {
                        this.tryClose();
                    }
                })
            })

            params.push({
                favorite: true,
                action: this.actions.add(new GAction({
                    caption: "jres:32000682", //RC 32000682 : Bez připomínek
                    tooltip: "jres:32000751", //RC 32000751 : Doplnit důvod vyřízení "Bez připomínek"
                    name: "actAddWithoutComment",
                    run: () => {
                        this.setBezPripominek(view);
                    } 
                }))
            })

            params.push({
                favorite: true,
                action: this.actions.add(new GAction({
                    icon: "fa-check-circle g-state-text g-state-info",
                    caption: "jres:32000926", //RC 32000926 : Vyřídit bez připomínek
                    tooltip: "jres:32000927", //RC 32000927 : Doplní se důvod vyřízení "Bez připomínek" a provede se vyřízení.
                    name: "actSettlementNoReason",
                    run: () => {
                        this.setBezPripominek(view);
                        this.runSettlement(view);
                    }
                }))
            })


            //if (this.EpkParams.epk_asyncvyriz === 1) {
            //    console.log("Asynchronní vyřízeno je povoleno.");

            //    params.push({
            //        favorite: true,
            //        //primary: true,
            //        action: this.actions.add(new GAction({
            //            icon: "fa-check-circle g-state-text g-state-info",
            //            caption: "jres:32000923", //RC 32000923 : Asynchronní vyřízení
            //            name: "actAsyncSettlement",
            //            run: () => {

            //            }
            //        }))
            //    })

            //}

            params.push({
                favorite: true,
                primary: true,
                action: this.actions.add(new GAction({
                    icon: "fa-check-circle g-state-text g-state-info",
                    caption: "jres:32000610", //RC 32000610 : Vyřídit
                    name: "actSettlement",
                    run: () => {
                        this.runSettlement(view);
                    }
                }))
            })

            

            this.commandBar(params);
        }

        private setBezPripominek(view: Gordic.Data.View<Gordic.Wfl.Interface.GPodpisovaKnihaDto>) {
            var rows = view.getDataRows();
            rows.map((item) => {
                this.hideFlash(this.flashIdValidateGridErrors);
                this.hideFlash(this.flashIdAddWithoutComment);
                //if (item.zpus_vyriz === Wfl.Interface.GWflczpvEnum.VracenoKPrepracovani || this.EpkParams.epk_shreaspos === true) {
                // doplnit pouze do prázdných políček
                if (item.vyrizeni_txt == null || item.vyrizeni_txt === "") {
                    item.vyrizeni_txt = "jres:32000682"; //RC 32000682 : Bez připomínek
                    view.updateData(rows);
                    this.showFlash({ id: this.flashIdAddWithoutComment, content: "jres:32000750", state: "success" }); //RC 32000750 : Důvod vyřízení "Bez připomínek" byl doplněn.
                }
                //}
            });
        }

        //#region --- GRID FORMAT ---

        /** nastavení formátu gridu */
        private createGridFormat() {

            let format = new Gordic.Data.GridFormat();

            format
                .addIconColumn({
                    name: this.outputStateColumnName,
                    caption: "jres:32000229", //RC 32000229 : Stav vyřízení
                    iconTemplate: (data) => {
                        //#region -- iconTemplate --
                        var template: IconTemplate = { icon: "", tooltip: "" };
                        if (data[this.outputStateColumnName] === true) {   // success
                            template.icon = "fa-check-circle g-state-text g-state-success";
                        }
                        else if (data[this.outputStateColumnName] === false) { // fail
                            template.icon = "fa-times-circle g-state-text g-state-error";
                        }
                        template.tooltip = data.statetooltip == null ? "" : data.statetooltip;
                        return template;
                        //#endregion
                    }
                })
            format
                .addTextColumn({
                    name: "ixp",
                    width: 140,
                    caption: "jres:26265020", //RC 26265020 : Ixp
                })
                .addTextColumn({
                    name: "vec",
                    caption: "jres:26265010", //RC 26265010 : Věc
                    width: 150,
                })


            this.addColumnTypeOfSettlement(format);

            this.addColumnRequestType(format);

            format
                .addTextColumn({
                    name: "cj",
                    caption: this.EpkOpt.znackaShortText!,
                    width: 55,
                })
                .addTextColumn({
                    name: "soubor",
                    caption: "jres:26265014", //RC 26265014 : El. obraz
                    width: 215
                })

            format
                .addTextColumn({
                    name: this.vyrizeniTxtColumnName,
                    caption: "jres:32000582", //RC 32000582 : Důvod vyřízení
                    width: 150,
                    editor: {
                        widget: "gstringbox",
                        options: {
                            validators: [new Gordic.Validators.Required({
                                validate: (value, source) => {
                                    return this.validateReasonForSettlement(value, source);
                                }
                            })],
                            name: "duvodVyrizeniField",
                            model: "model." + this.vyrizeniTxtColumnName + "=value"
                        }
                    },
                })

            this.addBoolColumn(format, this.signFavorite, "jres:32000837"); //RC 32000837 : Podepsat obraz
            this.addBoolColumn(format, this.timeStampColumnName, "jres:32000577"); //RC 32000577 : Časové razítko
            this.addBoolColumn(format, this.convertColumnName, "jres:32000602"); //RC 32000602 : Konverze
            this.addBoolColumn(format, this.signAttachmentColumnName, "jres:32000603"); //RC 32000603 : Podepsat přílohy
            this.addBoolColumn(format, this.timestampAttachmentColumnName, "jres:32000604"); //RC 32000604 : Časové razítko (přílohy)
            this.addBoolColumn(format, this.convertAttachmentColumnName, "jres:32000605"); //RC 32000605 : Zkonvertovat (přílohy)
            this.addBoolColumn(format, this.signAttachmentNoPDFColumnName, "jres:32000606"); //RC 32000606 : Podepsat i ne-PDF přílohy

            return format;
        }

        private validateReasonForSettlement(value, source) {
            var zpusobVyrizeni: Wfl.Interface.GWflczpvEnum = source.closest('.row').findFields("zpusobVyrizeniField").gfield("getValue");
            if ((value == null || value === "") && (zpusobVyrizeni === Wfl.Interface.GWflczpvEnum.VracenoKPrepracovani))
                return false;
            else
                return true;
        }

        //#region ---- ZPŮSOB VYŘÍZENÍ ----

        /**
         * přidat sloupec způsob vyřízení
         * @param format formát sloupce
         */
        private addColumnTypeOfSettlement(format: Data.GridFormat<any>) {
            var name = this.zpusVyrizColumnName;
            format
                .addTextColumn({
                    name: name,
                    caption: "jres:32000583", //RC 32000583 : Způsob vyřízení
                    cellTemplate: (row: Gordic.Wfl.Interface.GPodpisovaKnihaDto) => {
                        //#region -- cellTemplate --
                        if (row != null && row[name] != null) {
                            if (row[name] === Wfl.Interface.GWflczpvEnum.Povoleno) {
                                return "jres:32000585";     //RC 32000585 : Kladné vyřízení
                            }
                            else if (row[name] === Wfl.Interface.GWflczpvEnum.VracenoKPrepracovani) {
                                return "jres:32000584";     //RC 32000584 : Vráceno k přepracování
                            }
                        }
                        return "jres:32000609"; //RC 32000609 : Nevyřízeno
                        //#endregion
                    },
                    width: 175,
                    editor: (ctx) => {
                        var cell = ctx.cellInfo;
                        if (ctx != null && cell != null && cell.column != null && cell.data.aktivita === 100) {     // vyhledáme zvolenou buňku
                            if ((cell.data[name] === Wfl.Interface.GWflczpvEnum.Povoleno) || (cell.data[name] === Wfl.Interface.GWflczpvEnum.VracenoKPrepracovani)) {
                                return this.setTypeOfSettlementEditorField(name);
                            }
                        }
                        return null;
                    }
                })

        }

        /**
         * editor způsobu vyřízení
         * @param field název políčka
         */
        private setTypeOfSettlementEditorField(field: string) {

            var data: IEpkTypeSettlement[] = [];
            data.push({ caption: "jres:32000585", value: Wfl.Interface.GWflczpvEnum.Povoleno }); //RC 32000585 : Kladné vyřízení
            data.push({ caption: "jres:32000584", value: Wfl.Interface.GWflczpvEnum.VracenoKPrepracovani }); //RC 32000584 : Vráceno k přepracování
            var view = new Data.View(data);

            var editor: GGridColumnEditorOption<IEpkTypeSettlement> = {
                widget: "gselectbox",
                options: {
                    validators: [new Gordic.Validators.Required({
                        validate: (value, source) => { return (value == null || value === "") ? false : true; }
                    })],
                    graphicInput: "hidden",
                    name: "zpusobVyrizeniField",
                    model: "model." + field + "=value.value",
                    data: view,
                    itemTemplate: (value) => {
                        return value?.caption;
                    },
                    clientFilterEvaluator: false,
                    dropdown: true,
                    change: (ev, obj) => {

                        var data = obj.value;
                        var state = false;

                        if (data != null && data.value === Wfl.Interface.GWflczpvEnum.Povoleno)
                            state = true;

                        this.setStatesOnEditeColumns(state);
                    }
                }
            };
            return editor;
        }

        //#endregion

        //#region ---- TYP POŽADAVKU ----

        /**
         * přidat sloupec typ požadavku
         * @param format formát sloupce
         */
        private addColumnRequestType(format: Data.GridFormat<any>) {
            var name = this.typPozadPodColumnName;
            format
                .addTextColumn({
                    name: name,
                    caption: "jres:26265012", //RC 26265012 : Typ požadavku
                    tooltipTemplate: (row) => {
                        return this.getTypPozadPodTxt(row.typ_pozad_pod);
                    },
                    cellTemplate: (row) => {
                        return this.getTypPozadPodTxt(row.typ_pozad_pod);
                    },
                    editor: (ctx) => {
                        //#region -- editor --
                        var cell = ctx.cellInfo;
                        if (ctx != null && cell != null && cell.column != null && cell.column.field === name && cell.data.aktivita === 100) {     // vyhledáme zvolenou buňku
                            var list = this.getArrayTypPozadPod(cell.data);
                            // pokud metoda s výběrem nic nevrátí nebo pokud vrátí jeden záznam, který je zároveň initial hodnotou, tak tak nedovolím editaci
                            if (list.length === 0 || (list.length === 1 && list[0].typ_pozad_pod === cell.data[name])) {
                                return null;
                            }
                            // spuštění editace
                            else {
                                return this.setRequestTypeEditorField(list);
                            }
                        }
                        return null;
                        //#endregion
                    },
                    width: 155
                })

        }

        private getArrayTypPozadPod(row: Gordic.Wfl.Interface.GPodpisovaKnihaDto) {

            var data: { typ_pozad_pod: Wfl.Interface.TypPozadavkuEpk, typ_poz_txt: string }[] = [];
            var dto = this.setStateOnRow(row);

            // když je volba vynucená, tak je ji nutné zobrazit
            var forceSchvalit = dto.schvalit.enabled === false && dto.schvalit.checked === true;
            var forcePodepsat = dto.podepsat.enabled === false && dto.podepsat.checked === true;

            if ((dto.podepsat.checked === true || dto.podepsat.enabled === true) && forceSchvalit === false) {
                data.push({ typ_pozad_pod: Wfl.Interface.TypPozadavkuEpk.Podepsat, typ_poz_txt: "jres:32000572" }) //RC 32000572 : Podepsat
            }
            if ((dto.schvalit.checked === true || dto.schvalit.enabled === true) && forcePodepsat === false) {
                data.push({ typ_pozad_pod: Wfl.Interface.TypPozadavkuEpk.Schvalit, typ_poz_txt: "jres:32000573" }); //RC 32000573 : Schválit
            }

            if ((this.schvalit.enabled === false && this.schvalit.checked === false) || (this.podepsat.enabled === false && this.podepsat.checked === false))
                return data;
            else {
                data.push({ typ_pozad_pod: Wfl.Interface.TypPozadavkuEpk.PodepsatASchvalit, typ_poz_txt: "jres:32000566" }) //RC 32000566 : Podepsat a schválit
                return data;
            }
        }

        private getTypPozadPodTxt(typ_pozad_pod?: Wfl.Interface.TypPozadavkuEpk | null) {
            return getTypPozadPodTxtUtils(typ_pozad_pod);
        }

        private setRequestTypeEditorField(data) {
            var view = new Data.View(data);
            var editor: GGridColumnEditorOption<any> = {
                widget: "gselectbox",
                options: {
                    validators: [new Gordic.Validators.Required({
                        validate: (value, source) => { return (value == null || value === "") ? false : true; }
                    })],
                    graphicInput: "hidden",
                    name: "typPozadavkuField",
                    model: "model.typ_pozad_pod=value.typ_pozad_pod",
                    data: view,
                    itemTemplate: (value) => {
                        var typ_poz_txt = this.getTypPozadPodTxt(value.typ_pozad_pod);
                        return typ_poz_txt;
                    },
                    clientFilterEvaluator: false,
                    dropdown: true,
                    change: (ev, obj) => {

                        if (obj.value != null) {
                            var field = this.findFields(this.signFavorite + "Field");
                            switch (obj.value.typ_pozad_pod) {
                                case Wfl.Interface.TypPozadavkuEpk.Podepsat:
                                case Wfl.Interface.TypPozadavkuEpk.PodepsatASchvalit:
                                    field.gfield("setInitial", true);
                                    break;
                                case Wfl.Interface.TypPozadavkuEpk.Schvalit:
                                    field.gfield("setInitial", false);
                                    break;
                            }
                        }

                        //var state = false;
                        //if (obj.value != null && (obj.value.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.Podepsat || obj.value.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.PodepsatASchvalit))
                        //    state = true;
                        //this.setStatesOnEditeColumns(state);
                    }
                }
            }
            return editor;
        }

        //#endregion

        //#region ---- BOOLEAN ANO/NE ----

        private addBoolColumn(format: Data.GridFormat<any>, name: string, caption: string) {
            format
                .addTextColumn({
                    name: name,
                    caption: caption,
                    width: 130,
                    cellTemplate: (row) => {
                        return this.setBooleanEditorFieldItemTemplate(row[name], row.typ_pozad_pod);
                    },
                    editor: (ctx) => {
                        var cell = ctx.cellInfo;
                        if (ctx != null && cell != null && cell.column != null && cell.column.field === name) {     // vyhledáme zvolenou buňku
                            var initialValue: boolean = cell.data[name] == null ? false : cell.data[name];
                            var enabled = this.setVisibility(name, cell.data);
                            return this.setBooleanEditorField(name, initialValue, enabled);
                        }
                        return null;
                    },
                    
                })
        }

        /**
         * pokud není pole viditelné, tak v rámci hromadného vyřízení (kde je vidět), nejde aspoň editovat
         * thazmuka (02.06.2021)
         */
        private setVisibility(name: string, row: Gordic.Wfl.Interface.GPodpisovaKnihaDto) {

            var typ_pozad_pod: Wfl.Interface.TypPozadavkuEpk = row.typ_pozad_pod!;

            var enabled = typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.Podepsat ||
                typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.PodepsatASchvalit;

            if (typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.Schvalit) {
                if (name === this.signFavorite) {
                    enabled = false;
                }
                if (name === this.signAttachmentColumnName && this.states.podepsatPrilohy.visible === true) {
                    var dto = this.setStateOnRow(row);
                    if (this.EpkParams.epk_povpodppri === true && dto.podepsatPrilohy.checked === true)
                        enabled = true;
                }
            }

            if (name === this.timeStampColumnName && (row.prizCasRazitko! > -1))                      // thazmuka (6.8.2021) - zablokování editace časového razítka OBRAZU z důvodu vynucení čas. razítka na šabloně důvodu podpisu
                enabled = false;
            else if (name === this.timestampAttachmentColumnName && (row.prizCasRazitko! > -1 ))      // thazmuka (6.8.2021) - zablokování editace časového razítka PŘÍLOHY z důvodu vynucení čas. razítka na šabloně důvodu podpisu
                enabled = false;
            else if (name === this.timeStampColumnName && this.states.casoveRazitko.visible === false)
                enabled = false;
            else if (name === this.timestampAttachmentColumnName && this.states.casoveRazitkoPriloha.visible === false)
                enabled = false;
            else if (name === this.convertColumnName && this.states.zkonvertovat.visible === false)
                enabled = false;
            else if (name === this.convertAttachmentColumnName && this.states.zkonvertovatPrilohy.visible === false)
                enabled = false;
            else if (name === this.signAttachmentColumnName && this.states.podepsatPrilohy.visible === false)
                enabled = false;
            else if (name === this.signAttachmentNoPDFColumnName && this.states.podepsatPrilohyNePDF.visible === false)
                enabled = false;

            return enabled;
        }

        private setBooleanEditorFieldItemTemplate(value: boolean, typ_pozad_pod: Wfl.Interface.TypPozadavkuEpk) {
            // pokud se nejedná o typ požadavku při kterém dochází k podepisování, nemusím tuto informaci zobrazovat
            if (typ_pozad_pod !== Wfl.Interface.TypPozadavkuEpk.Podepsat && typ_pozad_pod !== Wfl.Interface.TypPozadavkuEpk.PodepsatASchvalit && typ_pozad_pod !== Wfl.Interface.TypPozadavkuEpk.Schvalit)
                return "";
            return value === true ? "jres:32000575" : value === false ? "jres:32000576" : "";   // Ano, Ne
        }

        private setBooleanEditorField(name: string, value: boolean, enabled: boolean) {
            var obj: GGridColumnEditorOption<boolean> = {
                widget: "gcheck",
                options: {
                    disabled: !enabled,
                    initialValue: value,
                    name: name + "Field",
                    model: "model." + name + "=value",
                    change: (ev, obj) => {
                        //if (name === this.signAttachmentColumnName) {
                        //    if (obj.value == null || obj.value === false) {
                        //        this.findFields(this.convertAttachmentColumnName + "Field").gfield("setValue", false);
                        //        this.findFields(this.timestampAttachmentColumnName + "Field").gfield("setValue", false);
                        //        this.findFields(this.signAttachmentNoPDFColumnName + "Field").gfield("setValue", false);
                        //    }
                        //}
                    }
                }
            }
            return obj;
        }

        //#endregion

        private setStatesOnEditeColumns(enabled: boolean) {
            var fields = this.findFields(this.signFavorite + "Field", this.timeStampColumnName + "Field", this.signAttachmentColumnName + "Field", this.convertColumnName + "Field", this.convertAttachmentColumnName + "Field", this.timestampAttachmentColumnName + "Field", this.signAttachmentNoPDFColumnName + "Field")
            fields.gfield("option", { disabled: !enabled });
            if (enabled === false)
                fields.gfield("setInitial", false);
        }

        /** nastavení sloupců na prohledávání */
        private searchColumns(format: Gordic.Data.GridFormat) {
            var searchColumns = [] as string[];
            for (var index = 0; index < format.columns.length; index++) {
                var columns = format.columns[index];
                if (columns.name !== undefined) {
                    searchColumns.push(columns.name);
                }
            }
            return searchColumns;
        }

        //#endregion

        //#region -- GRID --

        private createGrid(view: Gordic.Data.View<Gordic.Wfl.Interface.GPodpisovaKnihaDto>, format: Gordic.Data.GridFormat, searchColumns: string[]) {
            this.grid = $("<div>").gautofit();
            this.grid.ggrid({
                rowsEnabled: (metarow: any) => {
                    return metarow.data.aktivita === 100 ? true : false;
                },
                data: view,
                name: "gridHromadneVyrizeni",
                renderMode: "auto",										// auto, all-at-once, paged-sync, paged-async
                columnMode: "full",										// fit (defaultne by melo byt toto), full
                navigationMode: "row",									// row, cell
                //sloupce, podle kterych se vyhledava v searchboxu
                searchColumns: searchColumns,
                columns: format,
                selection: (ev, obj) => {
                    // výběr řádků
                    var rows = obj.getSelection();
                    // vybírám jen jeden řádek
                    this.row = rows.length === 1 ? rows[0] : null;
                }, 
            })

            //#region -- ggridroweditor --
            this.grid
                .ggridroweditor({
                    commit: (a, b) => {
                        this.validateGridErrors(view, false);
                    }
                })
            //#endregion

            this.grid.appendTo(this.element);
        }

        private flashIdValidateGridErrors = "flashIdValidateGridErrors";

        /** provedení validace chybu na seznamu */
        private validateGridErrors(view: Gordic.Data.View<Gordic.Wfl.Interface.GPodpisovaKnihaDto>, showFlash: boolean) {

            var errors: object[] = view.getRows(true).reduce((prev: any, item: any) => {
                if (item == null || item.errors == null)
                    return prev;
                if ((item.errors.length ?? 0) > 0) {
                    prev.push.apply(prev, item.errors);
                }
                return prev;
            }, [])

            this.hideFlash(this.flashIdValidateGridErrors);
            if (errors != null && errors.length > 0 && showFlash === true)
                this.showFlash({ id: this.flashIdValidateGridErrors, state: "error", content: "jres:32000599" }); //RC 32000599 : Je třeba vyplnit povinné hodnoty.

            return errors;
        }

        //#endregion

        //#endregion

        //#region -- SET STATES --

        private setStateOnRow(row: Gordic.Wfl.Interface.GPodpisovaKnihaDto) {
            // nastavení vstupních hodnot pro upřesnění vyřízení
            var dto = this.common.setInitSettlementValues(this);
            dto = this.setCheckOnRows(row, dto);
            dto = this.setEnableOnRows(row, dto);
            return dto;
        }

        private setCheckOnRows(row: Wfl.Interface.GPodpisovaKnihaDto, dto: GEpkRowState) {

            dto.podepsat.checked = row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.Podepsat || row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.PodepsatASchvalit;
            dto.schvalit.checked = row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.Schvalit || row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.PodepsatASchvalit;
            dto.podepsatPrilohy.checked = row.s_pri !== 0 || (this.EpkParams.epk_zaskpril === "1");
            dto.posoudit.checked = row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.Posoudit;
            dto.vzitnavedomi.checked = row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.VzitNaVedomi;

            // speciality pro UKR
            dto.splnit.checked = row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.Splnit;
            dto.rozhodnout.checked = row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.Rozhodnout;

            // specialita pro MD (thazmuka - 8.2.2021)
            dto.pridelit.checked = row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.Prideleni;
            dto.pridelit.checked = row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.Predani;
            dto.pridelit.checked = row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.SchvalitVyrizeniSpisu;

            // zde probíhá nastavení property checked, visible
            this.common.loadCheckBoxSettingsMulti(dto, row, this);

            if (row.prizCasRazitko! > -1) {
                dto.casoveRazitko.checked = row.prizCasRazitko === 0 ? false : true;
                dto.casoveRazitkoPriloha.checked = row.prizCasRazitko === 0 ? false : true;
            }

            dto.casoveRazitko.checked = dto.casoveRazitko.checked && dto.podepsat.checked;
            dto.podepsatPrilohy.checked = dto.podepsatPrilohy.checked && (dto.podepsat.checked || this.common.canChangeRequestType(this.EpkParams.ssl_epk_zmeuko!, row.typ_pozad_pod));
            dto.casoveRazitkoPriloha.checked = dto.casoveRazitkoPriloha.checked && dto.podepsatPrilohy.checked;
            dto.zkonvertovat.checked = dto.zkonvertovat.checked && dto.podepsat.checked;
            dto.zkonvertovatPrilohy.checked = dto.zkonvertovatPrilohy.checked && dto.podepsatPrilohy.checked;
            dto.podepsatPrilohyNePDF.checked = dto.podepsatPrilohyNePDF.checked && dto.podepsatPrilohy.checked;

            return dto;

        }

        private setEnableOnRows(row: Wfl.Interface.GPodpisovaKnihaDto, dto: GEpkRowState) {

            //#region -- existuje úkon schválení --
            var existujeUkonSchvaleni = false;
            if (row.ixs_spd != null && row.ixs_spd != "") {
                existujeUkonSchvaleni = row.poc_posouz != 0;
            }
            //#endregion

            var jizVyrizen = false; //row.zpus_vyriz !== 0 ? true : false;
            var jeSystemovyUkon = row.sys_ukon != null ? true : false;
            var readOnly = this.isReadOnly == null ? false : this.isReadOnly;
            var jePevnaSablona = row.rezim_sch === 0 ? true : false;        // thazmuka (28.03.2021) - v případě pevné šablony nelze měnit typ žádosti

            var canRequestBeSigned = this.common.canRequestBeSigned(this.EpkParams.ssl_epk_zmeuko!, row.typ_pozad_pod);
            var canChangeRequestType = this.common.canChangeRequestType(this.EpkParams.ssl_epk_zmeuko!, row.typ_pozad_pod);

            // thazmuka (29.10.2020) - po konzultaci s M.Halíkem upraveno: když lze podepsat pouze přílohy a lze měnit typy požadavků, nekontroluji schvalovací proces
            // thazmuka (14.6.2022) - přidáno do multi vyřízení, kde chybělo
            // v TK to není takto správně obslouženo
            if (this.EpkParams.epk_povpodppri! === true && canChangeRequestType === true) {
                dto.podepsat.enabled = this.common.jeVyrizenSysUkonKeCteni(jizVyrizen, jeSystemovyUkon, readOnly, jePevnaSablona) === false && canRequestBeSigned && canChangeRequestType && (this.EpkOpt.povoleniUkonuPodpisuEpk!);
                dto.schvalit.enabled = this.common.jeVyrizenSysUkonKeCteni(jizVyrizen, jeSystemovyUkon, readOnly, jePevnaSablona) === false && canRequestBeSigned && canChangeRequestType && existujeUkonSchvaleni === false;
            }
            else {
                dto.podepsat.enabled = (row.dat_vyriz_plan == null || row.priz_rsp !== 10) && this.common.jeVyrizenSysUkonKeCteni(jizVyrizen, jeSystemovyUkon, readOnly, jePevnaSablona) === false && canRequestBeSigned && canChangeRequestType && (this.EpkOpt.povoleniUkonuPodpisuEpk!);
                dto.schvalit.enabled = (row.dat_vyriz_plan == null || row.priz_rsp !== 10) && this.common.jeVyrizenSysUkonKeCteni(jizVyrizen, jeSystemovyUkon, readOnly, jePevnaSablona) === false && canRequestBeSigned && canChangeRequestType && existujeUkonSchvaleni === false;
            }

            // TUTO HODNOTY UŽIVATEL NEMŮŽE MĚNIT (po domluvě s M.Halik 22.4.2020)
            dto.posoudit.enabled = false;
            dto.vzitnavedomi.enabled = false;
            dto.splnit.enabled = false;
            dto.rozhodnout.enabled = false;
            dto.pridelit.enabled = false;
            dto.predat.enabled = false;
            dto.schvaleniVyrizeniSpisu.enabled = false;

            // thazmuka (19.8.2021) - zde se nastaví pouze hodnota čas. razítka dle db parametru (řízení a viditelnost)
            // v případě použití šablony důvodu podpisu se hodnota nastaví při otevření dialogu upřesnění vyřízení či pak pro sichr až při samotném vyřízení
            if (this.EpkParams.gin_sgn_ktgdp === false)  // pokud nejsou aktivovány kategorie důvodu podpisu
                dto.casoveRazitko.enabled = canRequestBeSigned && dto.podepsat.checked;
            //dto.casoveRazitko.enabled = row.prizCasRazitko! > -1 ? false : canRequestBeSigned && dto.podepsat.checked;

            // thazmuka (19.8.2021) - zde se nastaví pouze hodnota čas. razítka dle db parametru (řízení a viditelnost)
            // v případě použití šablony důvodu podpisu se hodnota nastaví při otevření dialogu upřesnění vyřízení či pak pro sichr až při samotném vyřízení
            if (this.EpkParams.gin_sgn_ktgdp === false)  // pokud nejsou aktivovány kategorie důvodu podpisu
                dto.casoveRazitkoPriloha.enabled = dto.podepsatPrilohy.checked;
            //dto.casoveRazitkoPriloha.enabled = row.prizCasRazitko! > -1 ? false : dto.podepsatPrilohy.checked;

            dto.zkonvertovat.enabled = dto.podepsat.checked;
            dto.podepsatPrilohy.enabled = dto.podepsat.checked || (canRequestBeSigned && this.EpkParams.epk_povpodppri!) && row.priz_epk_pocet === 0 && row.s_pri === 0;
            dto.zkonvertovatPrilohy.enabled = dto.podepsatPrilohy.checked;
            dto.podepsatPrilohyNePDF.enabled = dto.podepsatPrilohy.checked;

            return dto;
        }

        private setNewPropertyToRow(row, dto: GEpkRowState) {

            // doplněný důvod vyřízení (thazmuka 15.7.2022)
            var settlementReason: string | null = null;
            if (row.ixp != null && row.ser_cislo != null) {
                var keyPath = String.Format("settlementReason.{0}{1}", row.ixp!, row?.ser_cislo?.toString());
                if (this.globalSettings != null && keyPath !== "") {
                    var value: string = this.globalSettings.get(keyPath);
                    settlementReason = value == null ? "" : value.trim();
                }
            }

            if (settlementReason != null) {
                row.vyrizeni_txt = settlementReason;
            }


            // uložení, že chci podepsat obraz
            row[this.signFavorite] = dto.podepsat.checked;
            row[this.timeStampColumnName] = dto.casoveRazitko.checked;
            row[this.timeStampColumnName + "Enabled"] = dto.casoveRazitko.enabled;
            row[this.convertColumnName] = dto.zkonvertovat.checked;
            row[this.convertColumnName + "Enabled"] = dto.zkonvertovat.enabled;
            row[this.signAttachmentColumnName] = dto.podepsatPrilohy.checked;
            row[this.signAttachmentColumnName + "Enabled"] = dto.podepsatPrilohy.enabled;
            row[this.timestampAttachmentColumnName] = dto.casoveRazitkoPriloha.checked;
            row[this.timestampAttachmentColumnName + "Enabled"] = dto.casoveRazitkoPriloha.enabled;
            row[this.convertAttachmentColumnName] = dto.zkonvertovatPrilohy.checked;
            row[this.convertAttachmentColumnName + "Enabled"] = dto.zkonvertovatPrilohy.enabled;
            row[this.signAttachmentNoPDFColumnName] = dto.podepsatPrilohyNePDF.checked;
            row[this.signAttachmentNoPDFColumnName + "Enabled"] = dto.podepsatPrilohyNePDF.enabled;
        }

        //#endregion

        //#region --- SETTLEMENT --

        private setLog(name: string, ixp: string, typPozadavku: any) {
            // thazmuka (30.03.2021) - zalogování do WK logu typ požadavku
            var typ_pozad_pod_txt = getTypPozadPodTxtUtils(typPozadavku);
            var message = String.Format("{0} - row: {1}, typ_pozad_pod: {2} ({3})", name, ixp, typPozadavku, typ_pozad_pod_txt);
            this.customLogger.info(message);
        }

        private runSettlement(view: Data.View<Gordic.Wfl.Interface.GPodpisovaKnihaDto>) {

            //TODO: VÝBĚR CERTIFIKÁTU MUSÍ BÝT JIŽ ZDE - 602 VĚTEV

            var obj = this.createEpkCompleteConfigDto(view);
            var errors = this.validateGridErrors(view, true);

            if (errors == null || errors.length === 0) {    
                var change = (opt: { Ixp: string, Success: boolean, Message?: string }[]) => {

                    if (opt == null)
                        return;

                    obj.rows.map((item) => {
                        for (var i = 0; i < opt.length; i++) {
                            var row = opt[i];
                            if (item.ixp === row.Ixp) {
                                item[this.outputStateColumnName] = row.Success;
                                if (row.Message != null)
                                    item[this.outputStateColumnName + "tooltip"] = row.Message;
                                view.updateData(obj.rows);
                                continue;
                            }
                        }
                    });

                };

                var done = () => {
                    console.info("jres:32000931") //RC 32000931 : Hromadné vyřízení v EPK bylo dokončeno.
                }

                // zablokuji tlacitko, aby neslo opakovane vyrizovat
                if (this.actions.actSettlement != null)
                    this.actions.actSettlement.update({ enabled: false });
                if (this.actions.actAddWithoutComment != null)
                    this.actions.actAddWithoutComment.update({ enabled: false });
                if (this.actions.actSettlementNoReason != null)
                    this.actions.actSettlementNoReason.update({ enabled: false });

                new Settlement({ cnt: this, change: change, done: done }).run(obj.configList)
                    ?.then((res) => {
                        if (res === 1) {    // povoleno znovuvyřízení v případě přerušení výběru certifikátu
                            if (this.actions.actSettlement != null)
                                this.actions.actSettlement.update({ enabled: true });
                            if (this.actions.actAddWithoutComment != null)
                                this.actions.actAddWithoutComment.update({ enabled: true });
                            if (this.actions.actSettlementNoReason != null)
                                this.actions.actSettlementNoReason.update({ enabled: true });
                        }
                    });

                return;

            }
        }

        private createEpkCompleteConfigDto(view: Data.View<Gordic.Wfl.Interface.GPodpisovaKnihaDto>) {
            const rows = view.getDataRows();
            const list = rows.map((row) => {
                //let signFavorite = (row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.Podepsat || row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.PodepsatASchvalit) ? true : false;
                let obj: Wfl.Interface.GEpkCompleteConfigDto = {
                    Ixp: row.ixp,
                    SerCislo: row.ser_cislo,
                    IxsDpo: row.ixs_dpo,
                    VyrizeniTxt: row.vyrizeni_txt,
                    TypPozadavku: row.typ_pozad_pod,
                    ZpusobVyrizeni: row.zpus_vyriz,
                    CasRazitko: row[this.timeStampColumnName],
                    CasRazitkoPrilohy: row[this.timestampAttachmentColumnName],
                    PodepsatObraz: row[this.signFavorite],
                    PodepsatPrilohy: row[this.signAttachmentColumnName],
                    PodepsatPrilohyNePdf: row[this.signAttachmentNoPDFColumnName],
                    PredPodepsanimKonvertovat: row[this.convertColumnName],
                    ZkonvertovatPrilohy: row[this.convertAttachmentColumnName]
                }
                // thazmuka (30.03.2021) - zalogování do WK logu typ požadavku před spuštění vyřízení, který jde na dialog
                this.setLog("BeforeSettlement", row.ixp!, row.typ_pozad_pod);
                return obj;
            });

            var listOfIxp = rows.map((row) => {
                if (row.ixp == null)
                    return "";
                return row.ixp;
            });

            return { rows: rows, configList: list, listOfIxp: listOfIxp };
        }

        //#endregion

 
    }

}

// todo: reagovat na db parametry tak, ze kdyztak nezobrazovat prislusne sloupce
// - snad vyreseno (02.06.2021)

// todo: nastavení výchozích hodnot doplněných sloupců, pokud nebudou zobrazeny
// - snad vyreseno (02.06.2021)

// todo: nejlepší způsob předání hodnot na server se mi jeví takový, že rozšířím dto o mé atributy a předám ho celý
// todo: zkontrolovat jak se bude chovat vyřízení (hlavně vizuální) když je vynuceno podepsat pouze přílohu
// todo: zatím vynechávám možnost k posouzení